import React from 'react';
import { Sparkles, X, RefreshCw } from 'lucide-react';

/**
 * AIReplyDraft - Component to display AI-generated reply draft with actions
 */
const AIReplyDraft = ({
  isVisible,
  draftText,
  onUse,
  onRefresh,
  onClose,
  isRefreshing = false,
  title = 'AI Suggested Reply',
  className = ''
}) => {
  if (!isVisible || !draftText) return null;

  return (
    <div className={`bg-purple-900/30 border border-purple-500/50 rounded-lg p-3 ${className}`}>
      {/* Header */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkles size={16} className="text-purple-400" />
          <span className="text-xs font-semibold text-purple-300">{title}</span>
        </div>
        <button 
          onClick={onClose}
          className="text-gray-400 hover:text-white transition-colors"
          data-testid="ai-draft-close"
        >
          <X size={14} />
        </button>
      </div>

      {/* Draft Content */}
      <p className="text-sm text-white mb-2 whitespace-pre-wrap">{draftText}</p>

      {/* Actions */}
      <div className="flex gap-2">
        <button 
          onClick={onUse}
          className="text-xs bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded transition-colors"
          data-testid="ai-draft-use"
        >
          Use This Draft
        </button>
        {onRefresh && (
          <button 
            onClick={onRefresh}
            disabled={isRefreshing}
            className="text-xs bg-gray-700 hover:bg-gray-600 text-white px-3 py-1 rounded flex items-center gap-1 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title="Generate new draft"
            data-testid="ai-draft-refresh"
          >
            <RefreshCw size={12} className={isRefreshing ? 'animate-spin' : ''} />
            {isRefreshing ? 'Generating...' : 'Refresh'}
          </button>
        )}
      </div>
    </div>
  );
};

export default AIReplyDraft;
